module.exports = __webpack_public_path__ + "media/0009.67ef8d38.mp3";